import { FunctionComponent } from "react";
import {
  /**
   * IMPORTANT! do not install `history` package manually.
   * @see https://reactrouter.com/docs/en/v6/routers/history-router
   */
  unstable_HistoryRouter as BaseHistoryRouter,
  HistoryRouterProps,
} from "react-router-dom";

import history from "./history";

const HistoryRouter: FunctionComponent<Omit<HistoryRouterProps, "history">> = ({
  basename,
  children,
}) => {
  return (
    <BaseHistoryRouter basename={basename} history={history}>
      {children}
    </BaseHistoryRouter>
  );
};

export default HistoryRouter;
